import { Container } from "react-bootstrap";
import About from "./About";
import Experience from "./Experience";
import Skills from "./Skills";
import Education from "./Education";
import Certifications from "./Certifications";
import Hobbies from "./Hobbies";
import Languages from "./Languages";
import CvHeader from "./CvHeader";
import { useRef } from "react";
import StickyNav from "./StickyNav";
import References from "./References";


const MobileViewCv = () => {

    const ref = useRef(); // Ref for the content to be converted to PDF

    return (

        <div className="mobile-view-cv">

            <CvHeader />

            <StickyNav />
            
            <Container className="cv-mobile-stack py-4" ref={ref}>
                <About />
                <Experience />
                <Education />
                <Skills />
                <Certifications />
                <Languages />
                <Hobbies />
                <References />
            </Container>

        </div>

    )

}

export default MobileViewCv;